const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// ============================================================
// نقطة إطلاق الحركة.
//
// Dawn الأصلي: -50px. هنا -80px عشان الحركة تبدأ والعنصر داخل
// الشاشة بوضوح — مع مسافة 4rem ومدة 700ms، -50px كانت بتخلي جزء
// من الحركة يحصل عند الحافة السفلية.
//
// السالب مهم: بيقلّص منطقة الكشف من تحت، يعني العنصر لازم يدخل
// **جوه** الشاشة قبل ما يتحرك. لو حد خلاها موجبة ('5%' مثلاً)
// العنصر هيبدأ حركته وهو لسه بره الشاشة وهتخلص قبل ما عينك
// توصلها — ده كان سبب إحساس "الأنيميشن ضعيف" قبل كده.
// ============================================================
const SCROLL_ANIMATION_ROOT_MARGIN = '0px 0px -80px 0px';

// هل الجهاز أو إعدادات المستخدم تسمح بالأنيميشن؟
function motionAllowed() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;

  const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (conn && conn.saveData) return false;
  if (conn && /^(slow-2g|2g)$/.test(conn.effectiveType || '')) return false;

  if (typeof navigator.deviceMemory === 'number' && navigator.deviceMemory < 2) return false;
  if (typeof navigator.hardwareConcurrency === 'number' && navigator.hardwareConcurrency < 4) return false;

  return true;
}

// لازم نلغي الأنيميشن بالكلاس ده مش بمجرد إننا منراقبش،
// لأن الـ CSS حاطط opacity: 0.01 على العناصر دي — لو سيبناها من غير مراقبة هتفضل مخفية
function cancelAnimations(elements) {
  elements.forEach((element) => {
    element.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
    element.classList.add(SCROLL_ANIMATION_CANCEL_CLASSNAME);
  });
}

// Scroll in animation logic
function onIntersection(elements, observer) {
  // ============================================================
  // عداد منفصل لكل حاوية بدل عداد واحد للدفعة كلها.
  //
  // العداد الواحد كان بيعد أي عنصر scroll-trigger في الدفعة —
  // عناوين السكشنات، البانرات، الكونتينرات — فأول كارت في الجريد
  // كان بياخد رقم 3 أو 4 حسب اللي فوقه في الصفحة، وكل الشبكة
  // بتتأخر على الفاضي.
  //
  // بالـ Map، كل <ul> بيرقّم ولاده من 0، ومستقل تمامًا عن أي
  // سكشن تاني بيتكشف في نفس اللحظة.
  //
  // العداد بيتصفّر مع كل نداء للمراقب (كل دفعة داخلة الشاشة)،
  // فالكارت رقم 40 بياخد 0 أو 1 مش 40 — يعني تأخيره بيفضل قصير
  // مهما تنزل في الصفحة.
  // ============================================================
  const orders = new Map();

  elements.forEach((element) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;

      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        if (elementTarget.hasAttribute('data-cascade') && !elementTarget.style.getPropertyValue('--animation-order')) {
          const parent = elementTarget.parentElement || document.body;
          const order = orders.get(parent) || 0;

          // setProperty بدل setAttribute('style') اللي كان بيمسح أي إنلاين ستايل تاني على العنصر
          elementTarget.style.setProperty('--animation-order', order);
          orders.set(parent, order + 1);
        }

        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      }

      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function releaseHold() {
  document.documentElement.classList.remove('anim-hold');
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) {
    releaseHold();
    return;
  }

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  if (!motionAllowed()) {
    cancelAnimations(animationTriggerElements);
    releaseHold();
    return;
  }

  // ============================================================
  // التجهيز ده هو اللي بيخلي ترتيب الكروت يشتغل على كل العناصر.
  //
  // كل عنصر بياخد scroll-trigger--offscreen الأول، حتى اللي ظاهر
  // على الشاشة دلوقتي. ساعتها السيليكتور :not(...--offscreen) في
  // base.css مبيطابقش حاجة، فمفيش أي أنيميشن بيبدأ.
  //
  // بعدها بنشيل anim-hold. الصفحة كلها في حالة سكون مقصود:
  // العناصر مخفية ومستنية، والمراقب هو اللي هيقرر مين يتحرك
  // وبأي ترتيب.
  //
  // أول نداء للمراقب (بيحصل في الفريم اللي بعده) بيلاقي العناصر
  // الظاهرة، بيرقّمها 0، 1، 2... وبيشيل عنها offscreen — فتبدأ
  // حركتها بالتدرّج الصح.
  //
  // الترتيب المهم هنا: نضيف offscreen **قبل** ما نشيل anim-hold.
  // لو اتعكس، هيبقى في فريم واحد كل العناصر فيه بتطابق :not()
  // وبتبدأ مع بعض — نفس المشكلة اللي بنحلها بالظبط.
  // ============================================================
  animationTriggerElements.forEach((element) => {
    element.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
  });

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: SCROLL_ANIMATION_ROOT_MARGIN,
  });

  animationTriggerElements.forEach((element) => observer.observe(element));

  releaseHold();
}

// Zoom in animation logic
//
// ============================================================
// النسخة الأصلية كانت بتعمل **IntersectionObserver + scroll
// listener لكل عنصر على حدة**. صفحة فيها 6 بانرات زوم = 6
// مراقبين و6 لسنرز بيتنادوا كلهم في كل حدث سكرول، وكل واحد
// فيهم بيقرا getBoundingClientRect (يعني forced reflow) حتى
// لو العنصر بتاعه بره الشاشة خالص.
//
// النسخة دي: مراقب واحد ولسنر واحد، والقراءة بتحصل للعناصر
// الظاهرة بس، وكلها متجمّعة في نفس الـ frame عن طريق
// requestAnimationFrame — يعني reflow واحد بدل واحد لكل عنصر.
//
// الحسابات والنتيجة النهائية نفسها بالحرف.
// ============================================================
function initializeScrollZoomAnimationTrigger() {
  if (!motionAllowed()) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;
  const visible = new Set();
  let ticking = false;

  const update = () => {
    ticking = false;
    visible.forEach((element) => {
      element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
    });
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) visible.add(entry.target);
      else visible.delete(entry.target);
    });
    // عنصر لسه داخل الشاشة لازم ياخد قيمته الصح قبل أول سكرول
    requestUpdate();
  });

  animationTriggerElements.forEach((element) => {
    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
    observer.observe(element);
  });

  // rAF بيقفل معدل التحديث على معدل الرسم أصلاً، فمفيش لزوم
  // لـ throttle() — وده كمان بيشيل الاعتماد على دالة عايشة في
  // global.js وكانت بتضرب لو ترتيب تحميل الملفات اتغيّر
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

// ============================================================
// انتظار ستارة اللودر
// ------------------------------------------------------------
// اللودر (snippets/page-loader.liquid) بيغطي الشاشة بستارة معتمة
// وبيشيلها بعد DOMContentLoaded. المشكلة إن الملف ده كان بيسمع
// لنفس الحدث بالظبط، فالاتنين كانوا بيشتغلوا في نفس اللحظة:
//
//   t=0     الستارة معتمة  |  السلايد بدأ
//   t=800   الستارة راحت   |  السلايد خلص
//
// يعني الحركة كلها كانت بتحصل ورا الغطاء، وأول ما المستخدم يقدر
// يشوف الصفحة تكون كل حاجة استقرت. النتيجة: "مفيش سلايد أصلاً"
// على أول شاشة، بينما اللي تحت الطية شغال عادي.
//
// اللودر دلوقتي بيحط html.sa-loading وبيبعت theme:loader:done
// وهو بيختفي. الدالة دي بتربط الاتنين.
//
// ملاحظتين على التصميم:
//
// 1) لو الكلاس مش موجود (اللودر متقفل من الإعدادات، أو السنيبت
//    مش مركّب) الدالة بتنفّذ فورًا. مفيش أي اعتماد إجباري.
//
// 2) شبكة الأمان الـ 5 ثواني مش زيادة احتياط: العناصر دي عليها
//    opacity: 0.01 من الـ CSS. لو الحدث ماجاش لأي سبب (خطأ في
//    سكريبت تطبيق تاني وقف التنفيذ مثلاً) الصفحة هتفضل فاضية
//    للأبد. الرقم أطول من كل مؤقتات اللودر (أقصاها 4200ms).
// ============================================================
function whenCurtainLifted(callback) {
  if (!document.documentElement.classList.contains('sa-loading')) {
    callback();
    return;
  }

  let fired = false;
  const run = () => {
    if (fired) return;
    fired = true;
    callback();
  };

  document.addEventListener('theme:loader:done', run, { once: true });
  setTimeout(run, 5000);
}

window.addEventListener('DOMContentLoaded', () => {
  whenCurtainLifted(() => {
    initializeScrollAnimationTrigger();
    initializeScrollZoomAnimationTrigger();
  });
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}
